import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { routing } from './cartao.routing';
import { RootComponent } from './root/root.component';
import { CartaoComponent } from './pages/cartao/cartao.component';
import { SharedModule } from '@shared/shared.module';
import { AuthGuard } from '@core/guards/auth.guard';
import { FormsModule } from '@angular/forms';
import { CartaoService } from './services/cartao.service';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    routing,
    SharedModule
  ],
  declarations: [
    CartaoComponent,
    RootComponent,
  ],
  providers: [AuthGuard, CartaoService]
})
export class CartaoModule { }
